export default __webpack_public_path__ + "static/media/background.d647e57d.png";